import { render } from "./Title.vue?vue&type=template&id=8fe8f57e&scoped=true"
const script = {}

import "./Title.vue?vue&type=style&index=0&id=8fe8f57e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8fe8f57e"

export default script